<template>
    <div v-if="limitFiles" class="col-12 px-5">
        <div class="alert alert-danger">Por favor añada un solo archivo</div>
    </div>
    <div>
        <div class="dropzone-container mx-auto" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <input type="file" multiple name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"
                accept=".pdf, .png" />
            <label for="fileInput" class="file-label">
                <div v-if="isDragging">Suelta para insertar archivo</div>
                <div v-else>Arrastre el archivo aqui o <u>haz click aqui</u> para añadir.</div>
            </label>
            <div v-if="!loading && message !=''">
                {{ message }}
            </div>
            <div class="d-flex justify-content-center mx-auto preview-container mt-3" v-if="files.length">
                <div v-for="file in files" :key="file.name" class="preview-card">
                    <div class="position-relative">                      
                        <v-icon name="bi-file-earmark-text" scale="3.5" />
                        <p class="fileName">
                            {{ file.name }}
                        </p>
                    </div>
                </div>
            </div>           
        </div>
    </div>
    <div class="row mt-3 pt-3 pl-0 mx-auto">
        <div class="mx-auto">
            <button class="btn btn-primary generalPrimaryButton float-right mw-100" @click="uploadFiles()"
                :disabled="files.length < 1 || loading">Enviar
                <span v-if="loading">
                  <img src="../../../../../assets/loader.svg" height="25" alt="">
                </span>
            </button>
        </div>
    </div>
    <p class="generalTitleItemModal mt-5">DOCUMENTOS</p>
</template>

<script>
import axios from 'axios';

export default {
    name: "DropDocuments",
    data() {
        return {
            isDragging: false,
            files: [],
            limitFiles: false,
            loading: false,
            message: '',
        };
    },
    props: [
        'issue',
    ],
    methods: {
        onChange() {
            this.files = [...this.$refs.file.files];
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            if (e.dataTransfer.files.length < 2) {
                this.$refs.file.files = e.dataTransfer.files;
                this.onChange();
                this.limitFiles = false
            } else {
                this.limitFiles = true;
            }
            this.isDragging = false;
        },
        remove(i) {
            this.files.splice(i, 1);
        },
        uploadFiles() {
            this.loading = true;
            const files = this.files;
            const formData = new FormData();
            files.forEach((file) => {
                formData.append("file", file);
            });
            
            formData.append('description', 'descripcion');
            axios.post(`/incident/${this.issue}/document`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then((response) => {
                console.log(response)
                this.loading = false;
                this.message = 'fichero cargado correctamente';
                this.files = [];
                this.$emit("sendRefreshIssue",this.issue)

                setTimeout(() => {
                    this.message = '';
                }, 10000);
                
            }).catch((error) => {
                console.log(error)
                this.loading = false;
                this.message = 'Ha ocurrido un error';
                this.files = [];
                setTimeout(() => {
                    this.message = '';
                }, 10000);
              
            });
        },
    },
};
</script>
<style lang="scss">
#dropzone_whiteList {
    display: flex;
    flex-grow: 1;
    align-items: center;
    height: 30vh;
    justify-content: center;
    text-align: center;
}

.dropzone-container {
    padding: 3rem;
    width: 45rem;
    max-height: 30vh;
    background: #f7fafc;
    border: 1px solid #e2e8f0;
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
}

.preview-card {
    display: flex;
    padding: 5px;
    margin-left: 5px;
}

.preview-container {
    .close {
        font-size: 2.5rem;
        line-height: 0.4;
        font-weight: normal;
        position: absolute;
        top: 0;
        right: -12px;
    }

    .fileName {
        max-width: 100px;
        max-height: 45px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>